import React from "react";

export const DownArrowIcon = () => {
    return (
        <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={'down-arrow'}>
            <g filter="url(#filter0_d_111_2662)">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M16.4717 13.2455L16.9043 13.6633V16.078L15.2651 14.4948C15.0957 14.3311 15 14.1057 15 13.8701C15 13.1037 15.9205 12.7131 16.4717 13.2455ZM23.5713 15.6186L24.7349 14.4948C24.9043 14.3311 25 14.1057 25 13.8701C25 13.1232 24.1257 12.7331 23.571 13.2067V13.2074L20.3484 16.32C20.1546 16.5072 19.8474 16.5072 19.6537 16.32L16.9053 13.6654V16.0801L19.6537 18.7347C19.8474 18.9219 20.1546 18.9219 20.3484 18.7347L23.5713 15.6217V15.6186Z"
                      fill="#000"/>
            </g>
            <defs>
                <filter id="filter0_d_111_2662" x="-10" y="-13" width="60" height="60" filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feGaussianBlur stdDeviation="7.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_111_2662"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_111_2662" result="shape"/>
                </filter>
            </defs>
        </svg>
    );
}